import React from 'react';
import classNames from 'classnames';

import ClickIconWithNoPropagation from 'components/ClickIconWithNoPropagation';

import noteIcon from 'assets/icons/note-icon.svg';

import './styles.css';

interface NotesCountProps {
  notesCount: number;
  showNotification?: boolean;
  onClick?: (event: React.MouseEvent) => void;
}

// TODO: Delete the check for onClick when the migration is finished
const NotesCount = ({
  notesCount,
  showNotification,
  onClick
}: NotesCountProps) => (
  <div className="NotesCount colab-centered-v">
    {onClick && (
      <ClickIconWithNoPropagation onClick={onClick}>
        <img src={noteIcon} alt="Edit icon" />
      </ClickIconWithNoPropagation>
    )}
    {!onClick && <img src={noteIcon} alt="Edit icon" />}
    <div className={classNames('count colab-bold', {showNotification})}>
      {notesCount}
    </div>
  </div>
);

export default NotesCount;
